// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import('../node_modules/vuetify/dist/vuetify.min.css')

import * as firebase from 'firebase'
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'

Vue.use(Vuetify)
Vue.config.productionTip = false

var config = {
  apiKey: 'AIzaSyCh57b0VKqNWYxnTRsBbhkk9ziRx4gH9G8',
  authDomain: 'kristenevansdot.firebaseapp.com',
  databaseURL: 'https://kristenevansdot.firebaseio.com',
  projectId: 'kristenevansdot',
  storageBucket: 'kristenevansdot.appspot.com',
  messagingSenderId: '1050597465193'
}

firebase.initializeApp(config)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js